import { AxiosResponse } from 'axios'
import { UseMutateFunction } from '@tanstack/react-query'
import { FormInstance } from 'antd'
import { Socket } from 'socket.io-client'

export interface FormTransferProps {
  orderId?: string | undefined
  editData: any | null
  setEditData: React.Dispatch<React.SetStateAction<any>>
  loadingListWallet?: boolean
  loadingListBankAccount?: boolean
  form: FormInstance<any>
  paymentMethod: any
  setPaymentMethod: React.Dispatch<any>
  setStepNewBeneficiary: React.Dispatch<React.SetStateAction<number | null>>
  paramsBeneficiary: {
    start: number
    end: number
  }
  setParamsBeneficiary: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  dataListCompany: {
    total: number
    page: number
    pageSize: number
    totalPages: number
    items: []
  }
  beneficiarySelected: any
  setBeneficiarySelected: React.Dispatch<any>
  dataListWallet: {
    total: number
    page: number
    pageSize: number
    totalPages: number
    items: []
  }
  paramsWallet: {
    start: number
    end: number
  }
  setParamsWallet: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  walletSelected: any
  setWalletSelected: React.Dispatch<any>
  dataListBankAccount: {
    total: number
    page: number
    pageSize: number
    totalPages: number
    items: []
  }
  paramsBankAccount: {
    start: number
    end: number
  }
  setParamsBankAccount: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  bankAccountSelected: any
  setBankAccountSelected: React.Dispatch<any>
  sendCurrency: number | undefined
  setSendCurrency: React.Dispatch<React.SetStateAction<number | undefined>>
  paymentCurrency: number | undefined
  setPaymentCurrency: React.Dispatch<React.SetStateAction<number | undefined>>
  dataCompaniesDefault: any
  companyDefaultSelected: any
  setCompanyDefaultSelected: React.Dispatch<any>
  paramsWalletProvider: {
    start: number
    end: number
  }
  setSearchDefaultCompany: React.Dispatch<any>
  setParamsWalletProvider: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  walletSelectedProvider: any
  setWalletSelectedProvider: React.Dispatch<any>
  dataListWalletProvider: any
  paramsBankAccountProvider: {
    start: number
    end: number
  }
  setParamsBankAccountProvider: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  bankAccountSelectedProvider: any
  setBankAccountSelectedProvider: React.Dispatch<any>
  dataListBankAccountProvider: any
  getDetailSendMoney: UseMutateFunction<
    AxiosResponse<any, any>,
    unknown,
    number,
    unknown
  >
  setOpenAddWallet: React.Dispatch<React.SetStateAction<boolean>>
  setOpenAddBankAccount: React.Dispatch<React.SetStateAction<boolean>>
  loadingDetail: boolean
  socket: Socket<any, any>
  companyDefaultCurrency: any
  loadingCompanyCurrency: boolean
  loadingDefaulCompany: boolean
  dataAllCurrency: any[]
  onChangeDisabledPortfolio?: (value: boolean) => void
  reloadRateFeeKey?: number
  handleChangeBeneficiary: () => void
}

export const listPayFee = [
  {
    value: 'sender',
    label: 'Sender pays fee',
  },
  {
    value: 'beneficiary',
    label: 'Beneficiary pays fee',
  },
]

export const listMethod = {
  CRYPTO_FIAT: 'CRYPTO_FIAT',
  CRYPTO_CRYPTO: 'CRYPTO_CRYPTO',
  FIAT_CRYPTO: 'FIAT_CRYPTO',
  FIAT_FIAT: 'FIAT_FIAT',
}

export const listTransferMode = {
  CRYPTO_NETWORK: 'CRYPTO_NETWORK',
  BANK_TRANSFER: 'BANK_TRANSFER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
}

export const listPaymentMethod = {
  PORTFOLIO: 'PORTFOLIO',
  DIRECTER_TRANSFER: 'DIRECTER_TRANSFER',
}

export const Fiat = [
  'USD',
  'EUR',
  'HKD',
  'AUD',
  'JPY',
  'CHF',
  'CNY',
  'AED',
  'SGD',
  'GBP',
]
export const Crypto = ['USDT', 'DAI', 'ETH']
